export default "__VITE_ASSET__iSUY7ljG__"